// export const GROUP_ID_WEBCAST = 38; // local
// export const GROUP_ID_EVENT = 39; // local

export const GROUP_ID_WEBCAST = 45; // produktiv
export const GROUP_ID_EVENT = 46; // produktiv
